// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"d6428ee2","64":"751a92c6","232":"e90c115a","453":"f2df4e05"}[chunkId] + ".chunk.js";
};